module.exports = __webpack_public_path__ + "static/arnold-dda07b1e7aef01bf521753b148c5106e.jpg";